import React from 'react';
import {Box, Chip, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {DARK_GREEN, GREY, RED, WHITE, YELLOW} from '../../../../BerendsohnMUITheme';
import {STATUS_COLORS, STATUS_LABELS} from './constants';

const useStyles = makeStyles((theme) => ({
    chip: {
        color: WHITE,
        fontWeight: 'bold',
    },
    scoreBar: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.75),
    },
    scoreTrack: {
        width: 48,
        height: 6,
        backgroundColor: theme.palette.grey[300],
        borderRadius: 3,
        overflow: 'hidden',
    },
    scoreFill: {
        height: '100%',
    },
}));

export function StatusBadge({status}: {status: string}) {
    const classes = useStyles();
    return (
        <Chip
            label={STATUS_LABELS[status] ?? status}
            size="small"
            className={classes.chip}
            style={{
                backgroundColor: STATUS_COLORS[status] ?? GREY,
                color: status === 'uncertain' ? 'rgba(0,0,0,0.87)' : undefined,
            }}
        />
    );
}

export function ScoreBar({score}: {score: number | null}) {
    const classes = useStyles();
    if (score === null) return <Typography variant="caption" color="textSecondary">—</Typography>;
    const pct = Math.round(score * 100);
    const color = score >= 0.8 ? DARK_GREEN : score >= 0.5 ? YELLOW : RED;
    return (
        <Box className={classes.scoreBar}>
            <div className={classes.scoreTrack}>
                <div className={classes.scoreFill} style={{width: `${pct}%`, backgroundColor: color}}/>
            </div>
            <Typography variant="caption">{pct} %</Typography>
        </Box>
    );
}
